import { createFileRoute } from '@tanstack/react-router';
import { TeamLearningPage } from '@/pages/learning/TeamLearningPage';

export const Route = createFileRoute('/_authenticated/_app/team-learning')({
	component: TeamLearningPage,
});
